import _ from "lodash";
import moment from "moment";
import { editCart } from "@redux/booking/slice";
import { getListingBookings, getPpayment } from "@redux/booking/actions";

const prepareCheckoutPayload = (cartData) => {
  return cartData.map((item) => ({
    courseId: item.courseId.courseId,
    productId: item.completeDetails.products[0].mid,
    time: moment(item.teetime).format("YYYY-MM-DDTHH:mm"),
    reserved: item.players,
  }));
};

const handlePayment = async (cartData, dispatch) => {
  const payload = prepareCheckoutPayload(cartData);
  const res = await dispatch(getPpayment(payload));

  if (res?.payload?.status === 200 && res?.payload?.data?.data?.golfPass) {
    const supplementRates = res?.payload?.data?.data?.supplementRates || [];
    const updatedCart = cartData.map((item) => {
      const supplement = supplementRates.find(
        (x) => x?.facilityId === item.clubId && x?.price?.amount > 0
      );
      const suplementPrice = supplement?.price;
      const totalSuplement_Price = suplementPrice
        ? suplementPrice.amount * item.players
        : 0;

      return {
        ...item,
        suplementPrice,
        totalSuplement_Price,
      };
    });

    dispatch(editCart(updatedCart));
    return { success: true };
  }

  return {
    message:
      res?.payload?.response?.data?.message ||
      `Hmm... there was an issue with your checkout. Please refresh and try again.`,
    success: false,
  };
};

export async function checkBookingCondition(props, t, dispatch) {
  if (!props) return { message: "not booked", success: false };

  const cartData = [...props].sort(
    (a, b) => new Date(a.teetime) - new Date(b.teetime)
  );

  const hasPastTeeTimes = cartData.some((e) =>
    moment().isAfter(e.teetime, "minute")
  );
  if (hasPastTeeTimes) {
    return { message: t("teeTime.remove_Past_Tees"), success: false };
  }

  const uniqueMids = new Set();
  const uniqueArray = cartData.filter((item) => {
    const key = `${item.clubId}-${item.courseId.courseId}`;
    if (uniqueMids.has(key)) return false;
    uniqueMids.add(key);
    return true;
  });

  if (uniqueArray.length < 3 || uniqueArray.length > 5) {
    return {
      message: `You have selected ${uniqueArray.length} out of min 3/ max 5 courses`,
      success: false,
    };
  }

  const clubMap = {};
  cartData.forEach((item) => {
    if (!clubMap[`${item.clubId}-${item.courseId.courseId}`]) {
      clubMap[`${item.clubId}-${item.courseId.courseId}`] = {
        clubName: item.clubName,
        totalPlayers: 0,
      };
    }
    clubMap[`${item.clubId}-${item.courseId.courseId}`].totalPlayers +=
      item.players;
  });

  const firstClubId = `${cartData[0].clubId}-${cartData[0].courseId.courseId}`;
  const firstPlayerTotal = clubMap[firstClubId].totalPlayers;

  const mismatchedClubs = Object.entries(clubMap)
    .filter(
      ([clubId, data]) =>
        parseInt(clubId) !== firstClubId &&
        data.totalPlayers !== firstPlayerTotal
    )
    .map(([, data]) => data.clubName);

  if (mismatchedClubs.length > 0) {
    return {
      message: `Total number of players should be the same in each course.\nYou are selecting different numbers of players in ${mismatchedClubs}.\nPlease select number of players ${firstPlayerTotal} for each course.`,
      success: false,
    };
  }

  const fromDate = moment(cartData[0].teetime)
    .subtract(1, "day")
    .format("DD-MM-YYYY");
  const toDate = moment(cartData[cartData.length - 1].teetime)
    .add(1, "day")
    .format("DD-MM-YYYY");

  const res = await dispatch(getListingBookings({ fromDate, toDate }));

  const listingData = res?.payload?.data?.data?.data;
  const isBookingValid =
    res?.payload?.status === 200 && Array.isArray(listingData);

  if (isBookingValid) {
    const mergedMap = {};
    cartData.forEach((item) => {
      const key = `${item.clubId}-${item.courseId.courseId}`;
      if (!mergedMap[key]) {
        mergedMap[key] = { ...item };
      } else {
        mergedMap[key].players += item.players;
      }
    });

    const updatedCart = Object.values(mergedMap);

    const grouped = {};
    listingData.forEach((item) => {
      if (item.status === "BOOKED") {
        const key = `${item.teetime}_${item.course}_${item.facilityId}`;
        if (!grouped[key]) {
          grouped[key] = { ...item };
        } else {
          grouped[key].players += item.players;
        }
      }
    });

    const updatedListing = Object.values(grouped);

    const overbooked = updatedCart.filter((r) => {
      const matches = updatedListing.filter(
        (e) =>
          moment(e.teetime).isSame(moment(r.teetime)) &&
          e.facilityId === r.clubId &&
          e.course === r.course &&
          ["BOOKED", "CREATED"].includes(e.status) &&
          r.players > 4 - e.players
      );

      const totalBooked = matches.reduce((sum, item) => sum + item.players, 0);

      return (
        matches.length > 0 && (totalBooked >= 4 || 4 - totalBooked < r.players)
      );
    });

    if (overbooked.length > 0) {
      return { message: t("teeTime.teeTime_is_Book"), success: false };
    }
  }

  return await handlePayment(cartData, dispatch);
}
